import { DividerLine } from "./DividerLine";
import React from "react";
import styled from "styled-components";

type ReactDivProps = React.HTMLAttributes<HTMLDivElement>;

const StyledInnerPanelSubHeader = styled.div`
  min-height: 48px;
  display: flex;
  align-items: center;
  padding: 0px 16px;
`;

export const PanelSubHeader = ({ children }: ReactDivProps) => (
  <StyledInnerPanelSubHeader>{children}</StyledInnerPanelSubHeader>
);

PanelSubHeader.displayName = "PanelSubHeader";

export const PanelContentDividerLine = ({ margin = 12 }) => (
  <DividerLine margin={margin} />
);

PanelContentDividerLine.displayName = "PanelContentDividerLine";
